module.exports = __webpack_public_path__ + "static/img/program_prehrane_web_korisnici.236c71e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/program_prehrane_web_korisnici.png?v=28.01.2026
// module id = 7GKh
// module chunks = 0